import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import { MessageCircle, Phone } from "lucide-react";
import { PHONE_TEL, waLink } from "../../data";

export const FloatingCTA = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <>
          <motion.a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="floating-whatsapp-btn"
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0, opacity: 0 }}
            whileHover={{ scale: 1.08 }}
            className="fixed bottom-5 right-5 z-50 grid h-14 w-14 place-items-center rounded-full bg-[#25D366] shadow-2xl"
            aria-label="Scrivi su WhatsApp"
          >
            <span className="absolute inset-0 animate-ping rounded-full bg-[#25D366]/40" />
            <MessageCircle className="relative h-7 w-7 text-white" strokeWidth={2.4} />
          </motion.a>

          <motion.a
            href={`tel:${PHONE_TEL}`}
            data-testid="floating-call-btn"
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0, opacity: 0 }}
            whileHover={{ scale: 1.08 }}
            className="fixed bottom-5 left-5 z-50 grid h-14 w-14 place-items-center rounded-full bg-[#FFC400] shadow-2xl sm:hidden"
            aria-label="Chiama ora"
          >
            <Phone className="h-6 w-6 text-[#0B1F3A]" strokeWidth={2.6} />
          </motion.a>
        </>
      )}
    </AnimatePresence>
  );
};

export default FloatingCTA;
